module.exports = __webpack_public_path__ + "static/media/YF90_1.92b7e96a.jpg";